<template>
    <div class="global-item-quantity form-group" :class="this.errorItemQuantity !== '' ? 'has-error': ''">
        <span class="global-item-quantity__label">
            <slot name="amount"/>
            <span v-if="max">(max: {{ max }})</span>
        </span>
        <div class="global-item-quantity__controls">
            <global-button theme="secondary" icon="minus" @click="decreaseQuantity" :disabled="quantityAsNumber <= min || disabled"/>
            <input class="form__input form__input--text"
                   type="text"
                   @input="setQuantity($event.target.value)"
                   :value="quantity || ''"
                   :disabled="disabled || min === max">
            <global-button theme="secondary" icon="plus" @click="increaseQuantity" :disabled="max && quantityAsNumber >= max || disabled"/>
            <div class="global-item-quantity__error form__error" v-show="errorItemQuantity !== ''" v-html="errorItemQuantity"></div>
            <div class="global-item-quantity__additional">
                <slot name="additional"/>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalButton from "@global/global-elements/global-button/global-button";

export default {
    name: "global-item-quantity",
    components: {GlobalButton},
    props: {
        storeAction: null,
        min: {
            type: Number,
            default: 1
        },
        value: {
            type: Number,
            default: 1
        },
        max: {
            type: Number,
            default: null
        },
        errorMessages: {
            type: Object,
            required: false,
            default: function() {
                return {
                    errorToSmall: typeof this.$t === 'function' ? this.$t('global-item-quantity.errorMin') : 'The amount you entered is too small. You have to order at least %min.',
                    errorToLarge: typeof this.$t === 'function' ? this.$t('global-item-quantity.errorMax') : 'The amount you entered ist too large. You can only order %max items.',
                    errorNotANumber: typeof this.$t === 'function' ? this.$t('global-item-quantity.errorFormat') : 'You must enter a number without algebraic signs.'
                }
            }
        },
        disabled: false
    },
    data() {
        return {
            quantity: this.value,
            errorItemQuantity: ''
        }
    },
    computed: {
        quantityAsNumber() {
            return parseInt(this.quantity)
        }
    },
    watch: {
        errorItemQuantity: function(newValue) {
            if (newValue.length) {
                this.$emit('updateErrorItemQuantity', true)
            } else {
                this.$emit('updateErrorItemQuantity', false)
            }
        }
    },
    methods: {
        setQuantity(value) {
            this.quantity = value
            this.validateInput(value);
        },
        increaseQuantity(e) {
            if (e.target.disabled) {
                return
            }
            if (isNaN(this.quantityAsNumber)) {
                this.setQuantity(1);
            } else {
                this.setQuantity(this.quantityAsNumber + 1);
            }
        },
        decreaseQuantity(e) {
            if (e.target.disabled) {
                return
            }
            if (isNaN(this.quantityAsNumber)) {
                this.setQuantity(1);
            } else {
                this.setQuantity(this.quantityAsNumber - 1);
            }
        },
        replacePlaceholder(translationString) {
            let replacedString = '';
            replacedString = translationString.split('%min').join(this.min.toString());
            if (this.max) {
                replacedString = replacedString.split('%max').join(this.max.toString());
            }
            return replacedString;
        },
        validateInput(value) {
            if (!/^\d+$/.test(value.toString())) {
                this.errorItemQuantity = this.replacePlaceholder(this.errorMessages.errorNotANumber);
                return
            }
            if (parseInt(value) < this.min) {
                this.errorItemQuantity = this.replacePlaceholder(this.errorMessages.errorToSmall);
                return
            }
            if (this.max && parseInt(value) > this.max) {
                this.errorItemQuantity = this.replacePlaceholder(this.errorMessages.errorToLarge);
                return
            }
            this.errorItemQuantity = '';
            this.$emit('updateCartData', this.quantityAsNumber);
        }
    }
}
</script>
